export const visibilityDurationMs = 6000
export const exitingAnimationDurationMs = 300

export const borderRadius = 9
export const shadowRadius = 9
export const shadowOffsetHeight = 8
export const shadowOffsetWidth = 4
export const shadowOpacity = 0.86
